export default {"src":"/_next/static/media/daura.44fb1480.svg","height":66,"width":211,"blurWidth":0,"blurHeight":0};